import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-271015b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import { onMounted, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPageView',
  setup(__props) {

const url = `${process.env.VUE_APP_BACKEND}/stats`;
const data = reactive({
  entries: "",
  unlabeled: "",
  unverified: "",
  verified: "",
});

async function getStats() {
  console.log("Fetching Data from ", url);
  await fetch(url, {
    method: "GET",
  })
    .then((res) => res.json())
    .then((res) => {
      console.log(res);
      data.entries = res.entries;
      data.unlabeled = res.unlabeled;
      data.unverified = res.unverified;
      data.verified = res.verified;
    });
}

onMounted(() => {
  getStats();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, (value, name, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: "datapoint"
      }, [
        _createElementVNode("b", null, _toDisplayString(name), 1),
        _createElementVNode("b", null, _toDisplayString(value), 1)
      ]))
    }), 128))
  ]))
}
}

})